import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
// import { asyncConnect } from 'redux-async-connect'
import CSSModules from 'react-css-modules'
import Styles from './ScreenedCompanies.css'
import config from '../../config'
import Loader from 'react-loader'
import { Link, LinkIcon } from '../'
import {SlideDown} from 'react-slidedown'
import * as searchActions from 'redux/modules/search'

@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)

// @asyncConnect([{
//   deferred: true, // need otherwise cient navigate is blocked until the page is loaded
//   promise: ({params, store: {dispatch, getState}}) => {
//     return dispatch(searchActions.companies())
//   }
// }])
@CSSModules(Styles)
export default class ScreenedCompanies extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
    // search: PropTypes.func,
  }
  constructor(props){
    super(props)
    this.state = {
      viewMoreTobacco: false,
      viewMoreMedia: false
    }
  }
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.props.companies()
  }

  componentWillReceiveProps(props){
    if (props.result) {
      let toCompanies = []
      let tmCompanies = []
      props.result.map((el)=>{
        if (el.is_to) toCompanies.push(el)
        if (el.is_tm) tmCompanies.push(el)
        return false
      })
      const _sorter = (a, b)=>{
        const lbl = 'short_name'
        const a_s = a[lbl].toLowerCase()
        const b_s = b[lbl].toLowerCase()
        return a_s.localeCompare(b_s)
      }
      toCompanies = toCompanies.sort(_sorter)
      tmCompanies = tmCompanies.sort(_sorter)
      this.setState({
        toCompanies,
        tmCompanies
      })
    }
  }

  clickViewMoreTobacco = () =>{
    this.setState({viewMoreTobacco: !this.state.viewMoreTobacco})
  }
  clickViewMoreMedia = () =>{
    this.setState({viewMoreMedia: !this.state.viewMoreMedia})
  }
  render() {
    if (!this.props.result) {
      return (
        <div styleName="main">
          <Loader
            options={{scale: 0.70, top:'4.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    // else if ( this.props.result && (!this.props.result.fund || !this.props.result.shareClass) ) {
    //   this.context.router.push(config.routes.notFound)
    //   return (
    //     <div styleName='main'>
    //       <Loader
    //         options={{scale: 0.70, top:'2.0rem'}}
    //         loaded={ false }
    //       />
    //     </div>
    //   )
    // }

    const toLabel = (!this.state.viewMoreTobacco ) ? 'View tobacco companies' : 'View less'
    const tmLabel = (!this.state.viewMoreMedia ) ? 'View entertainment studios' : 'View less'
    const toIcon = require( '../../../static/images/icon-cigarette.svg' )
    const tmIcon = require( '../../../static/images/icon-cinema.svg' )

    return (
      <div styleName='main-wrap'>
        <div styleName="company-table-wrapper">
          <div styleName='company-table-icon-wrap'>
            <img
              styleName="company-table-icon"
              src={toIcon}
              alt='Tobacco companies'
            />
            <div styleName="company-table-title-to">
              Tobacco companies
            </div>
          </div>
          <p>
            Identified using Morningstar industry categories, these companies either produce tobacco or manufacture tobacco products.
          </p>
          <button
            styleName="company-table-button-to"
            onClick={this.clickViewMoreTobacco}
            title={toLabel}
          >
            {toLabel}
            <LinkIcon
              faclass={(this.state.viewMoreTobacco)?'fa-angle-up':'fa-angle-down'}
            />
          </button>
          <SlideDown>
            { (this.state.viewMoreTobacco) ? (
                <table styleName='t-table'>
                  <thead>
                    <tr>
                      <th>Company</th>
                      <th>Symbol</th>
                      <th>Legal name</th>
                    </tr>
                  </thead>
                  <tbody>
                    { this.state.toCompanies.map((c, i)=>{
                      return (
                        <tr key={'to_'+i}>
                          <td>{c.short_name}</td>
                          <td>{c.primary_symbol}</td>
                          <td>{c.legal_name}</td>
                        </tr>
                      )
                    }) }
                  </tbody>
                </table>
              ) : null}
          </SlideDown>
        </div>

        <div styleName="company-table-wrapper">
          <div styleName='company-table-icon-wrap'>
            <img
              styleName="company-table-icon"
              src={tmIcon}
              alt='Entertainment companies'
            />
            <div styleName="company-table-title-tm">
              Entertainment companies
              </div>
          </div>
          <p>
            Visit our FAQs to learn how we identify tobacco-promoting entertainment companies that promote smoking to kids:&nbsp;
            <Link
              xstrong={true}
              to={config.routes.faq+'#2'}
              title='FAQ: Why entertainment companies?'
            >
              What do entertainment companies have to do with tobacco?<LinkIcon />
            </Link>
          </p>
          <button
            styleName="company-table-button-tm"
            onClick={this.clickViewMoreMedia}
            title={tmLabel}
          >
            {tmLabel}
            <LinkIcon
              faclass={(this.state.viewMoreMedia)?'fa-angle-up':'fa-angle-down'}
            />
          </button>
          <SlideDown>
            { (this.state.viewMoreMedia) ? (
                <table styleName='t-table'>
                  <thead>
                    <tr>
                      <th>Company</th>
                      <th>Symbol</th>
                      <th>Legal name</th>
                    </tr>
                  </thead>
                  <tbody>
                    { this.state.tmCompanies.map((c, i)=>{
                      return (
                        <tr key={'tm_'+i}>
                          <td>{c.short_name}</td>
                          <td>{c.primary_symbol}</td>
                          <td>{c.legal_name}</td>
                        </tr>
                      )
                    }) }
                  </tbody>
                </table>
              ) : null}
          </SlideDown>
        </div>

      </div>
    )
  }
}

